import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component(async (node) => {
  const closeBtns = node.querySelectorAll<HTMLButtonElement>('[data-close-btn]');
  const content = node.querySelector('[data-content]');
  const meta = node.querySelector('[data-meta]');

  const initDrawer = () => {
    const drawer = Drawer(node);

    drawer.on('open', () => {
      document.documentElement.style.overflow = 'hidden';
    });

    drawer.on('close', () => {
      document.documentElement.style.overflow = '';
    });

    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('cart')) {
      drawer.open();
    }

    document.addEventListener('cart:open', () => {
      drawer.open();
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        drawer.close();
      });
    });
  };

  const initContent = () => {
    document.addEventListener('cart:disable', () => {
      content.classList.add('cart-drawer__content--disabled');
    });

    document.addEventListener('cart:enable', () => {
      content.classList.remove('cart-drawer__content--disabled');
    });
  };

  const initUpdate = () => {
    document.addEventListener('cart:updated', (event: CustomEvent) => {
      const { cartDrawerMarkup } = event.detail;

      const temp = document.createElement('div');
      temp.innerHTML = cartDrawerMarkup;

      content.innerHTML = temp.querySelector('[data-content]').innerHTML;
      meta.innerHTML = temp.querySelector('[data-meta]').innerHTML;

      document.dispatchEvent(new Event('app:mount'));
      document.dispatchEvent(new Event('cart:open'));
    });
  };

  const init = () => {
    initDrawer();
    initContent();
    initUpdate();
  };

  init();
});
